export default "__VITE_ASSET__b62ab84d__"